import { Button, Divider, Grid, Icon, Input, InputLabel, Select } from '@scuf/common';
import { LabelDescription } from 'components';
import {
    getTotalBudgetFinal,
    getTotalProductsSelected,
    getTotalServices,
    getTotalWithOptional,
    getTotalwithoutOptional
} from 'helpers';
import { BudgetDetailsModel, WorkOrderBudgerModel } from 'models';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { REPAIR_CENTER, RMAFileAtom, cnpjMask, notificationAtom, telephoneMask } from 'resources';
import FileModal from './fileModal';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { Label } from '@mui/icons-material';
import useFetch from 'helpers/hooks/useFetch';
import { Coupon } from 'models/repaircenter/coupon';
type Props = {
    approveDetails: WorkOrderBudgerModel;
    onChangeInfo: CallableFunction;
};
const ApprovalInfo: React.FC<Props> = ({ approveDetails, onChangeInfo }: Props) => {
    const { t } = useTranslation(['repaircenter']);
    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const [fileName, setFileName] = useState<string>();
    const [fileUp, setFileUp] = useRecoilState<File | null>(RMAFileAtom);
    const [details, setDetails] = useState<BudgetDetailsModel>();
    const [coupon, setCoupon] = useState<Coupon>();
    const setNotification = useSetRecoilState(notificationAtom);
    const budget = approveDetails;
    const attrToChange = [
        'UserName',
        'Phone',
        'ServicesCnpj',
        'ServicesEmail',
        'PartsCnpj',
        'PartsEmail',
        'EmailXml',
        'Obs',
        'CouponName',
        'CouponDescription',
        'SalesOrder'
    ];
    const optional = ['Obs', 'CouponName'];
    const resetFile = (): void => {
        onChangeInfo('RequireOrderFile', null);
        setFileName('');
        setFileUp(null);
    };

    const [, getCoupon, loadingGetCoupons] = useFetch<{ couponName: string }, Coupon>({
        url: REPAIR_CENTER.getCouponByName,
        method: 'GET',
        onError: t('common:errors.Unexpected')
    });

    useEffect(() => {
        if (fileUp == undefined) return;
        approveDetails.approvedRequireOrderFile = fileUp;
    }, [fileUp]);

    useEffect(() => {
        if (coupon?.id) {
            onChangeInfo('CouponId', coupon?.id);
        } else {
            onChangeInfo('CouponId', null);
        }
    }, [coupon?.id]);

    const handleCheckCoupon = async (couponName?: string) => {
        if (couponName && couponName.length >= 1) {
            await handleGetCoupon(couponName);
        }
    };

    const handleGetCoupon = async (couponName: string) => {
        try {
            await getCoupon({ couponName }, async (resp: any) => {
                if (resp.data) {
                    if (resp.data.active == false) {
                        setCoupon(undefined);
                        setNotification(old => ({ ...old, message: t('Cupom Inativo'), type: 'information' }));
                    } else {
                        setCoupon(resp.data);
                        setNotification(old => ({ ...old, message: t('Cupom encontrado'), type: 'success' }));
                    }
                } else {
                    setCoupon(undefined);
                    setNotification(old => ({ ...old, message: t('Cupom não encontrado'), type: 'critical' }));
                }
            });
        } catch {
            setCoupon(undefined);
            setNotification(old => ({ ...old, message: t('Cupom não encontrado'), type: 'critical' }));
        }
    };

    return (
        <>
            <Divider />
            <Grid>
                <Grid.Column width={6}>
                    <h3>{t('rma.budget.Approval.Info')}</h3>
                    <Grid.Row>
                        {attrToChange.map((attr: string, index: number) => (
                            <Grid.Column width={6} key={attr}>
                                {attr !== 'SalesOrder' && attr !== 'CouponDescription' ? (
                                    <Input
                                        disabled={budget?.flagApproved !== 2}
                                        key={attr}
                                        label={t(`rma.budget.Approval.${attr}`)}
                                        value={(approveDetails[`approved${attr}` as keyof typeof approveDetails] as string) ?? ''}
                                        indicator={!optional.includes(attr) ? 'required' : 'optional'}
                                        fluid
                                        onEnter={() => {
                                            if (attr === 'CouponName') {
                                                if (
                                                    (
                                                        approveDetails[`approved${attr}` as keyof typeof approveDetails] as string
                                                    ).trim() == ''
                                                ) {
                                                    setCoupon(undefined);
                                                }
                                                handleCheckCoupon(
                                                    (
                                                        approveDetails[`approved${attr}` as keyof typeof approveDetails] as string
                                                    ).trim() ?? ''
                                                );
                                            }
                                        }}
                                        onBlur={() => {
                                            if (attr === 'CouponName') {
                                                if (
                                                    (
                                                        approveDetails[`approved${attr}` as keyof typeof approveDetails] as string
                                                    ).trim() == ''
                                                ) {
                                                    setCoupon(undefined);
                                                }
                                                handleCheckCoupon(
                                                    (
                                                        approveDetails[`approved${attr}` as keyof typeof approveDetails] as string
                                                    ).trim() ?? ''
                                                );
                                            }
                                        }}
                                        onChange={(value: string) => {
                                            if (attr.includes('Phone')) onChangeInfo(attr, telephoneMask(value));
                                            else if (attr.includes('Cnpj')) onChangeInfo(attr, cnpjMask(value));
                                            else onChangeInfo(attr, value);
                                        }}
                                    ></Input>
                                ) : attr === 'CouponDescription' ? (
                                    <LabelDescription
                                        title={t('rma.budget.Approval.CouponDescription')}
                                        value={
                                            coupon?.description
                                                ? coupon.description
                                                : (approveDetails[`approved${attr}` as keyof typeof approveDetails] as string)
                                                  ? (approveDetails[`approved${attr}` as keyof typeof approveDetails] as string)
                                                  : ''
                                        }
                                    ></LabelDescription>
                                ) : (
                                    <Select
                                        disabled={budget.flagApproved !== 2}
                                        label={t(`rma.budget.Approval.${attr}`)}
                                        placeholder="Selecione a opção"
                                        indicator="required"
                                        value={(approveDetails.approvedSalesOrder as boolean) ?? ''}
                                        options={[
                                            { value: true, text: 'Sim' },
                                            { value: false, text: 'Não' }
                                        ]}
                                        onChange={value => {
                                            onChangeInfo(attr, value);
                                        }}
                                    />
                                )}
                            </Grid.Column>
                        ))}
                        <Grid.Column width={6}>
                            <Button
                                disabled={
                                    approveDetails.approvedSalesOrder === false ||
                                    approveDetails.approvedSalesOrder === null ||
                                    approveDetails.flagApproved !== 2
                                }
                                icon={<Icon name="attachment" root="common" />}
                                size="small"
                                iconPosition="right"
                                content={t('common:actions.AddMotivo')}
                                onClick={() => setModalOpen(true)}
                            ></Button>

                            {isModalOpen && (
                                <FileModal
                                    onClose={() => setModalOpen(false)}
                                    open={isModalOpen}
                                    onAccept={(file: File) => {
                                        onChangeInfo('RequireOrderFile', file);
                                        setFileUp(file);
                                        setFileName(file.name);
                                    }}
                                    onReset={resetFile}
                                ></FileModal>
                            )}
                        </Grid.Column>
                        {fileName && (
                            <Grid.Column width={6}>
                                <h4>{`${t('common:translation.File')} ${fileName}`}</h4>
                                {<Icon name="delete" color="red" className="clickable" onClick={resetFile} />}
                            </Grid.Column>
                        )}
                    </Grid.Row>
                </Grid.Column>
                <Grid.Column width={6}>
                    <h3>{t('rma.budget.Order.Info')}</h3>
                    <Grid.Row className="grid-with-gap">
                        <Grid.Column width={4}>
                            <LabelDescription
                                title={t('rma.budget.Order.TotalWithOptionals')}
                                value={`R$ ${getTotalWithOptional(budget)}`}
                            ></LabelDescription>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <LabelDescription
                                title={t('rma.budget.Order.TotalWithOutOptionals')}
                                value={`R$ ${getTotalwithoutOptional(budget)}`}
                            ></LabelDescription>
                        </Grid.Column>

                        <Grid.Column width={4}>
                            <LabelDescription
                                title={t('rma.budget.Order.PISBenefit')}
                                value={
                                    budget.benefitPISCOFINS && budget.currency === 2
                                        ? `R$ ${(budget.amountPISCOF * budget.currencyRate).toFixed(2)}`
                                        : 0
                                }
                            ></LabelDescription>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <LabelDescription
                                title={t('rma.budget.Order.IPIBenefit')}
                                value={
                                    budget.benefitIPI && budget.currency === 2
                                        ? `R$ ${(budget.amountIPI * budget.currencyRate).toFixed(2)}`
                                        : 0
                                }
                            ></LabelDescription>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row className="grid-with-gap">
                        <Grid.Column width={4}>
                            <LabelDescription
                                title={t('rma.budget.Order.TotalSpareParts')}
                                value={`R$ ${getTotalProductsSelected(budget)}`}
                            ></LabelDescription>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <LabelDescription
                                title={t('rma.budget.Order.TotalServices')}
                                value={`R$ ${getTotalServices(budget).toFixed(2)}`}
                            ></LabelDescription>
                        </Grid.Column>
                        <Grid.Column width={4}>
                            <LabelDescription
                                title={t('rma.budget.Order.TotalICMSST')}
                                value={`R$ ${budget.amountST.toFixed(2)}`}
                            ></LabelDescription>
                        </Grid.Column>
                        <Grid.Column width={2}>
                            <LabelDescription title={t('rma.budget.Order.Total')}>
                                <div className="badge-total">{`R$ ${getTotalBudgetFinal(budget)}`}</div>
                            </LabelDescription>
                        </Grid.Column>
                    </Grid.Row>
                </Grid.Column>
            </Grid>
        </>
    );
};

export default ApprovalInfo;
